import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ContactsComponent} from './contacts/contacts.component';
import {TranslateModule} from '../../shared/pipes/translate/translate.module';
import {RecaptchaModule} from 'ng-recaptcha';
import {EstatesModule} from '../estates/estates.module';


@NgModule({
  declarations: [ContactsComponent],
  imports: [
    CommonModule,
    TranslateModule,
    RecaptchaModule,
    EstatesModule
  ],
  exports: [ContactsComponent],
})
export class ContactsModule {
}
